import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/supplierEvaluate/QueryPage'
export const queryPage2 = '/icps/system/sign/dataCollection/supplierEvaluate/QueryPageForSupplier'
export const Download = '/icps/system/sign/dataCollection/supplierEvaluate/exportList'
/*评价详情*/
export function queryDetailById(data) {
  return request({
    url: '/icps/system/sign/dataCollection/supplierEvaluate/queryDetailById',
    method: 'post',
    data
  })
}
/*评价申诉*/
export function evaluate(data) {
  return request({
    url: '/icps/system/sign/dataCollection/supplierEvaluate/evaluateAppeal',
    method: 'post',
    data
  })
}